import React from 'react';
import i18n from '../../../i18n/i18n';
import { Button, TextField, IconButton, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { wentRight, wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';
export default class AddMachine extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            masina_grupa: '',
            machineGroupType: [],
            masina_podgrupa: '',
            machineSubGroupType: [],
            masina: '',
            machineType: [],
            gps_provajder: '',
            gpsProvajderType: [],
            gps_broj_uredjaja: '',
            registarska_oznaka: '',
            machine_disabled: true,
            machine_subgroup_disabled: true,
            naziv: '',
            id: null,
        };
    };

    isEditMode = () => !!(this.props.edit || this.state.id);

    onInputchange(event) {
        this.setState({
        });
    }

    componentDidMount() {
        this.getByURL('machine_group/drop_down', 'machineGroupType');
        this.getByURL('gps/get_all', 'gpsProvajderType');
        this.populateForm(this.props);
    };

    componentDidUpdate(prevProps) {
        const prevKey = prevProps.data ? `${prevProps.data.id || prevProps.data.id_pogonska_masina || ''}-${prevProps.data.id_pogonska_masina_klijent || ''}` : null;
        const currentKey = this.props.data ? `${this.props.data.id || this.props.data.id_pogonska_masina || ''}-${this.props.data.id_pogonska_masina_klijent || ''}` : null;
        if (
            (this.props.add && !prevProps.add) ||
            this.props.edit !== prevProps.edit ||
            currentKey !== prevKey ||
            prevProps.lockSelection !== this.props.lockSelection
        ) {
            this.populateForm(this.props);
        } else if (!this.props.add && prevProps.add) {
            this.resetForm();
        }
    }

    getByURL(url, obj, params) {
        const config = params ? { params } : undefined;
        axios.get(`api/${url}`, config)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(() => wentWrong('Something went wrong, please try again!'));
    };

    resetForm = () => {
        this.setState({
            naziv: '',
            id: null,
            masina_grupa: '',
            masina_podgrupa: '',
            masina: '',
            gps_provajder: '',
            gps_broj_uredjaja: '',
            registarska_oznaka: '',
            machine_subgroup_disabled: true,
            machine_disabled: true,
            machineSubGroupType: [],
            machineType: []
        });
    }

    populateForm = (props) => {
        const data = (props && props.data) || {};
        const naziv = data.naziv || data.pogonska_masina || '';
        const id = data.id_pogonska_masina_klijent || (props.edit ? data.id : null) || null;
        const groupId = data.id_pogonska_masina_grupa || '';
        const subgroupId = data.id_pogonska_masina_podgrupa || '';
        const machineId = data.id_pogonska_masina || data.base_machine_id || '';
        const gpsProvider = data.id_gps_provajder || '';
        const gpsNumber = data.gps_broj_uredjaja || '';
        const plate = data.registarska_oznaka || '';
        const lockSelection = this.props.lockSelection;

        this.setState({
            naziv,
            id,
            masina_grupa: groupId,
            masina_podgrupa: subgroupId,
            masina: machineId,
            gps_provajder: gpsProvider,
            gps_broj_uredjaja: gpsNumber || '',
            registarska_oznaka: plate || '',
            machine_subgroup_disabled: lockSelection ? true : !groupId,
            machine_disabled: lockSelection ? true : !subgroupId
        }, () => {
            if (groupId) {
                this.loadSubgroups(groupId).then(() => {
                    if (subgroupId) {
                        this.loadMachines(subgroupId).then(() => {
                            if (machineId && this.state.machineType.length > 0 && !this.state.machineType.find(m => m.id === machineId)) {
                                this.setState(prev => ({ machineType: [...prev.machineType, { id: machineId, naziv: naziv || '' }] }));
                            }
                        });
                    } else {
                        this.setState({ masina: '', machineType: [], machine_disabled: true });
                    }
                });
            } else {
                this.setState({
                    machineSubGroupType: [],
                    machineType: [],
                    masina_podgrupa: '',
                    masina: '',
                    machine_subgroup_disabled: true,
                    machine_disabled: true
                });
            }
        });
    }

    loadSubgroups = (groupId) => {
        if (!groupId) {
            this.setState({ machineSubGroupType: [], machine_subgroup_disabled: true });
            return Promise.resolve();
        }
        return axios.get('api/machine_subgroup/drop_down', { params: { id_grupa: groupId } })
            .then(res => {
                const machineSubGroupType = res.data.data || [];
                this.setState({
                    machineSubGroupType,
                    machine_subgroup_disabled: this.props.lockSelection ? true : false
                });
            })
            .catch(err => {
                console.log(err);
                return Promise.resolve();
            });
    }

    loadMachines = (subgroupId) => {
        if (!subgroupId) {
            this.setState({ machineType: [], machine_disabled: true });
            return Promise.resolve();
        }
        return axios.get('api/machine/drop_down', { params: { id_podgrupa: subgroupId } })
            .then(res => {
                const machineType = res.data.data || [];
                this.setState({
                    machineType,
                    machine_disabled: this.props.lockSelection ? true : false
                });
            })
            .catch(err => {
                console.log(err);
                return Promise.resolve();
            });
    }

    handleGroupSelect = (groupId) => {
        this.setState({
            masina_grupa: groupId,
            masina_podgrupa: '',
            masina: '',
            machine_disabled: true,
            machine_subgroup_disabled: this.props.lockSelection ? true : !groupId
        }, () => {
            if (groupId) {
                this.loadSubgroups(groupId);
            } else {
                this.setState({ machineSubGroupType: [], machine_subgroup_disabled: true });
            }
        });
    }

    handleSubgroupSelect = (subgroupId) => {
        this.setState({
            masina_podgrupa: subgroupId,
            masina: ''
        }, () => {
            if (subgroupId) {
                this.loadMachines(subgroupId);
            } else {
                this.setState({ machineType: [], machine_disabled: true });
            }
        });
    }

    addMachine() {
        const isEdit = this.isEditMode();

        if (this.state.naziv && this.state.masina) {
            const { handleCreate } = this.props;

            let data = {
                id_pogonska_masina: this.state.masina,
                id_pogonska_masina_grupa: this.state.masina_grupa,
                id_pogonska_masina_podgrupa: this.state.masina_podgrupa,
                naziv: this.state.naziv,
                id_gps_provajder: this.state.gps_provajder,
                gps_broj_uredjaja: this.state.gps_broj_uredjaja,
                registarska_oznaka: this.state.registarska_oznaka,
            };

            if (isEdit && this.state.id) {
                data.id = this.state.id;
            }

            axios.post('api/machine/create_machine', data)
                .then(res => {
                    wentRight(i18n.t(isEdit ? 'Successfully updated machine' : 'Successfully added machine'));
                    handleCreate();
                })
                .catch(err => {
                    console.log(err);
                    wentWrong(i18n.t('Something went wrong, please try again!'))
                })

        } else wentWrong('Please enter all required fields!');
    };

    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    }

    closeEditDialog = () => {
        this.props.handleClose()
    }

    render() {
        return (
            <div style={{ padding: 20 }}>
                <Dialog open={this.props.add}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle disableTypography={true} style={{ background: '#04764e' }} className="responsive-dialog-title">{!this.props.edit ? i18n.t('Add machine') : i18n.t('Edit Machine')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <TextField required
                            label={i18n.t('Title')}
                            value={this.state.naziv}
                            style={{ width: '532px', marginBottom: '10px', marginTop: '20px', marginLeft: '10px' }}
                            InputLabelProps={{ shrink: this.state.naziv ? true : false }}
                            onChange={(e) => { this.setState({ naziv: e.target.value, field: null }); }} >
                        </TextField>

                        <TextField
                            label={i18n.t('Machine group name')}
                            select
                            disabled={this.props.lockSelection}
                            value={this.state.masina_grupa}
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: this.state.masina_grupa ? true : false }}
                            style={{ width: '256px', marginBottom: '10px', marginLeft: '10px' }}
                            onChange={(e) => this.handleGroupSelect(e.target.value)} >
                            <option value='' />
                            {this.state.machineGroupType.map((mg) => <option key={mg.id} value={mg.id}>{mg.naziv}</option>)}
                        </TextField>

                        <TextField
                            label={i18n.t('Machine subgroup name')}
                            select
                            disabled={this.props.lockSelection || this.state.machine_subgroup_disabled}
                            value={this.state.masina_podgrupa}
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: this.state.masina_podgrupa ? true : false }}
                            style={{ width: '256px', marginBottom: '10px', marginLeft: '10px' }}
                            onChange={(e) => this.handleSubgroupSelect(e.target.value)} >
                            <option value='' />
                            {this.state.machineSubGroupType.map((msg) => <option key={msg.id} value={msg.id}>{msg.naziv}</option>)}
                        </TextField>

                        <TextField
                            label={i18n.t('Model')}
                            select
                            disabled={this.props.lockSelection || this.state.machine_disabled}
                            value={this.state.masina}
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: this.state.masina ? true : false }}
                            style={{ width: '256px', marginBottom: '10px', marginLeft: '10px' }}
                            onChange={(e) => {
                                this.setState({ masina: e.target.value }, () => { });
                            }} >
                            <option value='' />
                            {this.state.machineType.map((msg) => <option key={msg.id} value={msg.id}>{msg.naziv}</option>)}
                        </TextField>

                        <TextField
                            label={i18n.t('Licence plate')}
                            value={this.state.registarska_oznaka}
                            style={{ width: '256px', marginBottom: '10px', marginLeft: '10px' }}
                            InputLabelProps={{ shrink: this.state.registarska_oznaka ? true : false }}
                            onChange={(e) => {
                                this.setState({ registarska_oznaka: e.target.value }, () => { });
                            }} >
                        </TextField>
                        {/* 
                        <TextField
                            label={i18n.t('GPS provider')}
                            select
                            value={this.state.gps_provajder}
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: this.state.gps_provajder ? true : false }}
                        style={{ width: '256px', marginBottom: '10px', marginLeft: '10px' }}
                        onChange={(e) => {
                            this.setState({ gps_provajder: e.target.value }, () => { });
                        }} >
                            <option value='' />
                            {(this.state.gpsProvajderType || []).map((gpsp) => <option key={gpsp.id} value={gpsp.id}>{gpsp.naziv}</option>)}
                        </TextField>

                        <TextField
                            label={i18n.t('GPS device number')}
                            value={this.state.gps_broj_uredjaja}
                            style={{ width: '256px', marginBottom: '10px', marginLeft: '10px' }}
                            InputLabelProps={{ shrink: this.state.gps_broj_uredjaja ? true : false }}
                            onChange={(e) => {
                                this.setState({ gps_broj_uredjaja: e.target.value }, () => { });
                            }} >
                        </TextField> */}

                        <div style={{ display: 'flex' }}>
                            <Button style={{ marginLeft: '10px', marginTop: '20px' }} variant="contained" color="primary" onClick={() => {
                                this.addMachine();
                            }}>
                                {this.isEditMode() ? i18n.t('Save') : i18n.t('Add')}
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </div >
        );
    };
};
